import React, { useEffect, useState } from "react";
import BaseLayout from "../../components/BaseLayout";
import HeaderBaseLayout from "../../components/HeaderBaseLayout";
import EmptyData from "../../components/EmptyDataScreen";
import CardContent from "./CardContent";
import ApiUtils from "../../utils/api_utils";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const AnnouncementPage = (props) => {
  const navigate = useNavigate();
  const { getAnnouncementList, getListLikes } = props;
  const [announcementList, setAnnouncementList] = useState([]);
  const [count, setCount] = useState(0);

  const handleClickCard = (id) => {
    navigate(PageRoutes.announcement + `/${id}`);
  };

  useEffect(() => {
    setCount(count + 1);
  }, [announcementList]);

  useEffect(() => {
    if (count == 2) {
      getLikeData();
    }
  }, [count]);

  const getLikeData = async () => {
    for (let i = 0; i < announcementList.length; i++) {
      const { status, data } = await getListLikes(
        announcementList[i].object.id
      );
      if (status == 200) {
        let updateLike = [...announcementList];
        updateLike[i].total_like = data.count;
        setAnnouncementList(updateLike);
      }
    }
  };

  const getData = async () => {
    const { status, data } = await getAnnouncementList();
    if (status == 200) {
      setAnnouncementList(data);
    } else {
      setAnnouncementList([]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <BaseLayout
      show_menu={false}
      isCustom={true}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Announcement"
          isCustomPicture={true}
          picture={`url(${process.env.PUBLIC_URL + "/SKOR-Announcement.png"})`}
          onClick={() => navigate(PageRoutes.home)}
        />
      }
    >
      <div className="announcement-content">
        {announcementList.length > 0 ? (
          announcementList &&
          announcementList.map((a, index) => (
            <CardContent
              image={ApiUtils.validateImgUrl({
                url: a?.object?.image?.display,
              })}
              name={a?.object?.name}
              description={a?.object?.description}
              logoLike={Assets.iconLikeSolid}
              countLike={a?.total_like == null ? "0" : a?.total_like}
              key={index}
              onClick={() => handleClickCard(a?.object?.id)}
            />
          ))
        ) : (
          <EmptyData
            title="There is no announcement"
            image={`${process.env.PUBLIC_URL + "/SKOR-Announcement-Empty.png"}`}
            imageStyle={{ width: "170px" }}
            bottomText="Stay tuned for company announcement here."
          />
        )}
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  announcementList: state.AnnouncementSM.announcementList,
});

const mapDispatchToProps = (dispatch) => ({
  getAnnouncementList: dispatch.AnnouncementSM.getAnnouncementList,
  getListLikes: dispatch.AnnouncementSM.getListLikes,
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementPage);
